<template>
  <button class="close-menu">
    <span class="sr-only">Close menu for {{ name }}</span>
    <span aria-hidden>Close</span>
    <i class="far fa-times"></i>
  </button>
</template>
<script>
  export default {
    name: 'CloseMegaMenu',
    props: {
      name: String,
    }
  }
</script>

<style lang="scss" scoped>
  .close-menu {
    float: right;
    display: flex;
    align-items: center;
    padding: 0;
    border: 0;
    background: transparent;

    svg {
      width: 13px;
      height: 20px;
      margin-left: 10px; 
      color: #000;
    }

    &:hover span {
      text-decoration: underline;
    }
  }
</style>
